import { refreshSharingTipsForAttachment } from '../actions/satchelV3Actions/publicActions';
import getAttachment from '../selectors/getAttachment';
import AttachmentModel from '../store/schema/AttachmentModel';
import { refreshExpirationDate } from 'owa-sharing-data';
import { orchestrator } from 'satcheljs';
import changeAttachmentPermission from '../actions/changeAttachmentPermission';
import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';

// TODO VSO 37978 - the attachment info string does not update while refreshing the expiration when refreshed
// through the infobar but it does when refreshed through the context menu
orchestrator(refreshExpirationDate, async actionMessage => {
    if (typeof actionMessage.id === 'object') {
        const attachment: AttachmentModel = getAttachment(actionMessage.id);
        if (!!attachment) {
            const refAttachment = attachment.model as ReferenceAttachment;

            await changeAttachmentPermission([actionMessage.id], refAttachment.PermissionType);
            refreshSharingTipsForAttachment(attachment.id);
        }
    }
});
